import EventEmitter from "eventemitter3";

const events = new EventEmitter();

const locked = new Map<string, number>();

function lock(name: string, id: number) {
  return new Promise((resolve) => {
    if(id === 1) {
      resolve(true)
    } else {
      events.once(`${name}${id-1}`, () => {
        resolve(true)
      })
    }
  });
}

async function unlock(name: string, id:number) {
  events.emit(`${name}${id}`);
  if(locked.get(name) === id) locked.delete(name)
}

export function async_mutex(name: string) {
  let id = 0;
  if (locked.has(name)) {
    const prev = locked.get(name) as number;
    id = prev + 1;
    locked.set(name, id)
  } else {
    id = 1;
    locked.set(name, id)
  }
  return {
    lock: async () => {
      await lock(name,id)
    },
    unlock: () => {
      unlock(name, id)
    }
  }
}
